import { InjectionToken } from '@angular/core'
import { io } from 'socket.io-client'

/** Socket.io クライアント生成処理をテスト時に差し替えるための共通トークン */
export const SOCKET_IO_FACTORY = new InjectionToken<typeof io>(
  'SOCKET_IO_FACTORY',
  {
    providedIn: 'root',
    factory: () => io,
  },
)
